import { Moment } from "moment";
import { Negociacao, SituacaoNota } from "./enum";

interface INotaParcial {
  id: string;
  dataPregao: Moment;
  usuario: string;
  corretora: string;
  upload?: string;
  tipoNegociacao: Negociacao;
  situacao: SituacaoNota;
  erro?: any;
}

interface INota extends INotaParcial {
  quantidadeOperacoes: number;
  valorLiquido: number;
  numeroNota?: string;
  taxaRegistro: number;
  iss: number;
  irrf: number;
  outrosCustos: number;
}

interface INotaBovespa extends INota {
  taxaLiquidacao: number;
  emolumentos: number;
  corretagem: number;
}

export class NotaBovespa implements INotaBovespa {
  public id!: string;
  public upload?: string;
  public usuario!: string;
  public dataPregao!: Moment;
  public situacao!: SituacaoNota;
  public corretora!: string;
  public numeroNota?: string;
  public taxaLiquidacao!: number;
  public emolumentos!: number;
  public corretagem!: number;
  public tipoNegociacao!: Negociacao;
  public quantidadeOperacoes!: number;
  public valorLiquido!: number;
  public taxaRegistro!: number;
  public iss!: number;
  public irrf!: number;
  public outrosCustos!: number;
  public erro?: any;

  constructor(param: INotaBovespa) {
    Object.assign(this, param);
  }
}

interface INotaBMF extends INota {
  irrfDaytrade: number;
  taxaOperacional: number;
  taxasBmf: number;
  outros: number;
}

export class NotaBMF implements INotaBMF {
  public irrfDaytrade!: number;
  public taxaOperacional!: number;
  public taxasBmf!: number;
  public outros!: number;
  public id!: string;
  public upload!: string;
  public usuario!: string;
  public corretora!: string;
  public tipoNegociacao!: Negociacao;
  public quantidadeOperacoes!: number;
  public valorLiquido!: number;
  public dataPregao!: Moment;
  public situacao!: SituacaoNota;
  public numeroNota?: string;
  public taxaRegistro!: number;
  public iss!: number;
  public irrf!: number;
  public outrosCustos!: number;
  public erro?: any;

  constructor(param: INotaBMF) {
    Object.assign(this, param);
  }
}

export class NotaParcial implements INotaParcial {
  public id!: string;
  public upload?: string;
  public usuario!: string;
  public dataPregao!: Moment;
  public situacao!: SituacaoNota;
  public erro?: any;
  public corretora!: string;
  public tipoNegociacao!: Negociacao;

  constructor(param: INotaParcial) {
    Object.assign(this, param);
  }
}
